@use '@lib/assets/styles/main.scss' as *;

.carousel {
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.carouselWithWrap {
  border-radius: 10px;
  background: $gray10;
  padding: 8px;
}

.leftNavWrap {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  z-index: 1;
}

.rightNavWrap {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  z-index: 1;
}

.hidden {
  visibility: hidden;
  pointer-events: none;
}

:root {
  [class*='swiper-button-loc']:disabled {
    display: none !important;
  }
}
